import React from "react";

class CSVLink extends React.Component {
  constructor(props) {
    if(typeof props.data !== 'string' || typeof props.filename !== 'string') {
      throw new Error('Invalid data or filename')
    }
    super(props)
  }

  downloadCsv = () => {
    const blob = new Blob([this.props.data], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    // Create a link to download it
    const download = document.createElement('a');
    download.href = url;
    download.setAttribute('download', this.props.filename);
    download.click();
  }

  render() {
    return <span onClick={this.downloadCsv}>{this.props.children}</span>
  }
}

export default CSVLink